var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"购物车","loading":_vm.loading}},[(!_vm.loading)?[_c('CartHeader'),_c('CartBody'),_c('CartFooter')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }